import { useTranslation as useTranslation$1 } from 'react-i18next';
import { TRANSLATION_FILE_RELATIVE_PATH } from '../services/i18n-language-service.js';

const useTranslation = () => useTranslation$1(TRANSLATION_FILE_RELATIVE_PATH);

export { useTranslation };
//# sourceMappingURL=use-translations.js.map
